import * as redux from 'react-redux'
import * as service from '@owl-nest/services'

/** @deprecated use `service.user.UseAuthExisting` from `@owl-nest/services` */
export type UseAuthExisting = service.user.UseAuthExisting
/** @deprecated use `service.user.UseAuthKnown` from `@owl-nest/services` */
export type UseAuthKnown = service.user.UseAuthKnown
/** @deprecated use `service.user.UseAuthNew` from `@owl-nest/services` */
export type UseAuthNew = service.user.UseAuthNew
/** @deprecated use `service.user.UseAuthUnknown` from `@owl-nest/services` */
export type UseAuthUnknown = service.user.UseAuthUnknown
/** @deprecated use `service.user.UseAuth` from `@owl-nest/services` */
export type UseAuth<EXTRA_FIELDS extends string = ''> = service.user.UseAuth<EXTRA_FIELDS>

/** @deprecated use `service.user.useAuth` from `@owl-nest/services` */
export function useAuth<EXTRA_FIELDS extends string = ''>(
  options: service.user.AuthOptions<EXTRA_FIELDS> = {},
): service.user.UseAuth<EXTRA_FIELDS> {
  const dispatch = redux.useDispatch()

  return service.user.useAuth({
    reduxDispatch: dispatch,
    ...options,
  })
}

/** @deprecated use `service.user.useSafeAuth` from `@owl-nest/services` */
export function useSafeAuth(): service.user.UseAuthLoggedin {
  const _auth = useAuth()
  if (_auth.type === 'loggedin') {
    return _auth
  }
  throw Error('the user is not loggedin !')
}

/** @deprecated use `service.user.isLoggedIn` from `@owl-nest/services` */
export function isLoggedIn(auth: service.user.UseAuth): auth is service.user.UseAuthLoggedin {
  return auth.type === 'loggedin'
}
